import { useEffect, useState } from "react";
import storageService from "../services/storageService";
import { STORAGE_KEYS } from "../constant/constant";
const DARK_MODE_CLASS = "builder-dark-mode";
const LIGHT_MODE_CLASS = "builder-light-mode";

const useDarkModeOn = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = storageService.get(STORAGE_KEYS.DARK_MODE);
    // return savedTheme ? JSON.parse(savedTheme) : window.matchMedia('(prefers-color-scheme: dark)').matches; //system theme preference
    return savedTheme ? JSON.parse(savedTheme) : false;
  });

  useEffect(() => {
    const body = document.body;
    const addClass = isDarkMode ? DARK_MODE_CLASS : LIGHT_MODE_CLASS;
    const removeClass = isDarkMode ? LIGHT_MODE_CLASS : DARK_MODE_CLASS;

    if (!body.classList.contains(addClass)) {
      body.classList.add(addClass);
    }
    body.classList.remove(removeClass);

    storageService.set(STORAGE_KEYS.DARK_MODE, isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return [isDarkMode, toggleDarkMode];
};

export default useDarkModeOn;
